import { useState } from "react";
import careerData from "./careerData";
import styles from "./AboutTimeline.module.css";

const AboutTimeline = () => {
  const [selectedId, setSelectedId] = useState(careerData[0].id);

  return (
    <div className={styles.timelineSection}>
      <h1 className={styles.heading}>MY MANY FACETS</h1>
      <div className={styles.accordionWrapper}>
        {careerData.map((career) => (
          <div
            key={career.id}
            className={`${styles.accordionItem} ${
              selectedId === career.id ? styles.active : ""
            }`}
            style={{ backgroundColor: career.tabColor }}
            onClick={() => setSelectedId(career.id)}
          >
            {selectedId === career.id ? (
              <div className={styles.activeContentWrapper}>
                <div className={styles.imageWrapper}>
                  <img
                    src={career.image}
                    alt={career.title}
                    className={styles.image}
                  />
                </div>
                <div className={styles.textWrapper}>
                  <h2 className={styles.title}>{career.title}</h2>
                  <p className={styles.description}>{career.description}</p>
                </div>
              </div>
            ) : (
              <span className={styles.label}>{career.label}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutTimeline;
